/* eslint-disable no-unused-vars */
import React from 'react';
import P from 'prop-types';
import c from 'classnames';
import _ from 'lodash';
import './Table.styl';

const getCellStyle = (field: any) => ({
  textAlign: field.align || 'left',
  flex: field.width ? `0 0 ${field.width}mm` : '1',
});

function TableHeader({ fields = [] }: { fields: any[] }) {
  return (
    <div className={c('mio-paper-row', 'mio-paper-header')}>
      {_.map(fields, field => (
        <div
          key={field.key}
          className="mio-paper-cell"
          style={getCellStyle(field)}
        >
          {field.title}
        </div>
      ))}
    </div>
  );
}

TableHeader.propTypes = {
  isRepeatedHeader: P.bool,
  fields: P.array,
};
TableHeader.defaultProps = {
  isRepeatedHeader: true,
  fields: [],
};

const cell = (data: any, field: any) => {
  let ret = '-';
  if (field.accessor && _.isFunction(field.accessor)) {
    ret = field.accessor(data);
  } else {
    ret = _.get(data, field.key, '-');
  }
  return ret;
};

function TableRow({
  data = {},
  fields = [],
  isOdd = false,
}: {
  data: any;
  fields: any;
  isOdd: any;
}) {
  return (
    <div className={c('mio-paper-row', { 'mio-paper-rowOdd': isOdd })}>
      {_.map(fields, field => (
        <div
          key={field.key}
          className="mio-paper-cell"
          style={getCellStyle(field)}
        >
          {cell(data, field)}
        </div>
      ))}
    </div>
  );
}

TableRow.propTypes = {
  data: P.array,
  fields: P.array,
  isOdd: P.bool,
  isRepeatedSectionItem: P.bool,
};

TableRow.defaultProps = {
  data: [],
  fields: [],
  isOdd: false,
  isRepeatedSectionItem: true,
};

function TableBottom() {
  return <div className="mio-paper-bottom" />;
}

function Table({ data = [], fields = [], bottom = TableBottom() }) {
  return {
    type: 'TABLE',
    isHeaderSettled: false,
    bottom,
    header: <TableHeader fields={fields} />,
    children: _.map(data, (row, i) => (
      <TableRow key={i} data={row} fields={fields} isOdd={(i + 1) % 2 === 1} />
    )),
  };
}

Table.Header = TableHeader;
Table.Row = TableRow;
Table.Bottom = TableBottom;

export default Table;
